<template>
  <div class="l-container--width-80">
    <h1>404</h1>
    <h4>Oh no! It looks like the page you're looking for doesn't exist.</h4>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>
